import React from 'react';
import { IoCalculator, IoBook, IoSchool } from 'react-icons/io5';
import AnimatedSection from '../ui/AnimatedSection';
import AnimatedCard from '../ui/AnimatedCard';

const Products = () => {
  const products = [
    {
      icon: <IoCalculator className="text-5xl" />,
      title: "Accounting Software",
      description: "Comprehensive accounting solution designed to streamline financial management for businesses of all sizes. Manage invoices, expenses, payroll, and financial reporting with ease.",
      features: [
        "Invoice Management",
        "Expense Tracking",
        "Financial Reporting",
        "Payroll Processing",
        "Tax Management",
        "Multi-currency Support"
      ],
      color: "from-green-500 to-green-600"
    },
    {
      icon: <IoBook className="text-5xl" />,
      title: "Learning Management System (LMS)",
      description: "Powerful e-learning platform that enables educational institutions and organizations to deliver, track, and manage online courses and training programs effectively.",
      features: [
        "Course Management",
        "Student Enrollment",
        "Progress Tracking",
        "Assessment Tools",
        "Certification",
        "Mobile Learning"
      ],
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: <IoSchool className="text-5xl" />,
      title: "School ERP System",
      description: "Complete school management solution that automates administrative tasks, streamlines academic operations, and enhances communication between students, parents, and staff.",
      features: [
        "Student Information System",
        "Attendance Management",
        "Grade & Report Cards",
        "Fee Management",
        "Timetable Management",
        "Parent-Teacher Portal"
      ],
      color: "from-purple-500 to-purple-600"
    }
  ];

  return (
    <section id="products" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Our Work</h2>
          </div>
        </AnimatedSection>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {products.map((product, index) => (
            <AnimatedCard key={index} index={index}>
              <ProductCard {...product} />
            </AnimatedCard>
          ))}
        </div>
      </div>
    </section>
  );
};

// Product Card Component
const ProductCard = ({ icon, title, description, features, color }) => {
  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="group dark-card rounded-xl transition-all duration-300 p-8 h-full flex flex-col relative z-10">
      <div className={`mb-6 bg-gradient-to-br ${color} text-white rounded-lg p-4 w-fit group-hover:scale-110 transition-transform duration-300 transform`}>
        {icon}
      </div>
      <h3 className="text-2xl font-bold mb-4 text-white group-hover:text-blue-400 transition-colors">{title}</h3>
      <p className="text-gray-300 mb-6 flex-grow leading-relaxed">{description}</p>
      <div className="border-t border-blue-500 border-opacity-20 pt-4">
        <h4 className="font-semibold text-white mb-3">Key Features:</h4>
        <ul className="space-y-2">
          {features.map((feature, idx) => (
            <li key={idx} className="flex items-start text-sm text-gray-400 group-hover:text-gray-300 transition-colors">
              <span className="text-blue-400 mr-2 font-bold">✓</span>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="mt-6">
        <a
          href="#contact"
          onClick={(e) => scrollToSection(e, 'contact')}
          className={`block w-full text-center bg-gradient-to-r ${color} hover:opacity-90 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 active:scale-95`}
        >
          Explore Product
        </a>
      </div>
    </div>
  );
};

export default Products;

